import { useContext } from 'react';
import { Context } from '@components/Context';

export const useCountry = () => {
  const { state } = useContext(Context);

  return { country: state.country };
};
